import data from './data.vue'
data.install = function (Vue) {
  Vue.component(data.name, data);
};
export default data



// WEBPACK FOOTER //
// ./src/ni-ui/no-data/index.js